/* Auto-generated by scripts/generate-theme-indexes.mjs */
import type { ThemePreset } from '@/lib/themes/types'

import { THEME_PRESET as THEME_PRESET_0 } from '../alternate-modes/blueprint-blackboard/theme'
import { THEME_PRESET as THEME_PRESET_1 } from '../alternate-modes/founders-edition/theme'
import { THEME_PRESET as THEME_PRESET_2 } from '../alternate-modes/legacy-mode/theme'
import { THEME_PRESET as THEME_PRESET_3 } from '../cosmic-scale/ascenscion-omega/theme'
import { THEME_PRESET as THEME_PRESET_4 } from '../cosmic-scale/aurora/theme'
import { THEME_PRESET as THEME_PRESET_5 } from '../cosmic-scale/aurora-lux/theme'
import { THEME_PRESET as THEME_PRESET_6 } from '../cosmic-scale/cosmic/theme'
import { THEME_PRESET as THEME_PRESET_7 } from '../cosmic-scale/cosmic-void/theme'
import { THEME_PRESET as THEME_PRESET_8 } from '../cosmic-scale/glacial-pulse/theme'
import { THEME_PRESET as THEME_PRESET_9 } from '../cosmic-scale/luminous-blue/theme'
import { THEME_PRESET as THEME_PRESET_10 } from '../cosmic-scale/nebula/theme'
import { THEME_PRESET as THEME_PRESET_11 } from '../cosmic-scale/nebula-iridium/theme'
import { THEME_PRESET as THEME_PRESET_12 } from '../cosmic-scale/nocturne-wave/theme'
import { THEME_PRESET as THEME_PRESET_13 } from '../cosmic-scale/orbital-slate/theme'
import { THEME_PRESET as THEME_PRESET_14 } from '../cosmic-scale/polar-aurora/theme'
import { THEME_PRESET as THEME_PRESET_15 } from '../cosmic-scale/solstice-aurum/theme'
import { THEME_PRESET as THEME_PRESET_16 } from '../cosmic-scale/supernova/theme'
import { THEME_PRESET as THEME_PRESET_17 } from '../cosmic-scale/supernova-prism/theme'
import { THEME_PRESET as THEME_PRESET_18 } from '../cosmic-scale/velvet-void/theme'
import { THEME_PRESET as THEME_PRESET_19 } from '../fantasy-realms/cyan-ember/theme'
import { THEME_PRESET as THEME_PRESET_20 } from '../fantasy-realms/jade-dragon/theme'
import { THEME_PRESET as THEME_PRESET_21 } from '../fantasy-realms/jade-dragon-aether/theme'
import { THEME_PRESET as THEME_PRESET_22 } from '../fantasy-realms/jade-terminal/theme'
import { THEME_PRESET as THEME_PRESET_23 } from '../fantasy-realms/phoenix/theme'
import { THEME_PRESET as THEME_PRESET_24 } from '../fantasy-realms/phoenix-ember/theme'
import { THEME_PRESET as THEME_PRESET_25 } from '../fantasy-realms/sakura/theme'
import { THEME_PRESET as THEME_PRESET_26 } from '../fantasy-realms/sakura-midnight/theme'
import { THEME_PRESET as THEME_PRESET_27 } from '../fantasy-realms/sakura-night/theme'
import { THEME_PRESET as THEME_PRESET_28 } from '../fantasy-realms/void-petal/theme'
import { THEME_PRESET as THEME_PRESET_29 } from '../minimal-atmosphere/mono/theme'
import { THEME_PRESET as THEME_PRESET_30 } from '../minimal-atmosphere/paper/theme'
import { THEME_PRESET as THEME_PRESET_31 } from '../minimal-atmosphere/zen-garden/theme'
import { THEME_PRESET as THEME_PRESET_32 } from '../neon-cyber/amber-circuit/theme'
import { THEME_PRESET as THEME_PRESET_33 } from '../neon-cyber/chrome-orchid/theme'
import { THEME_PRESET as THEME_PRESET_34 } from '../neon-cyber/cobalt-reactor/theme'
import { THEME_PRESET as THEME_PRESET_35 } from '../neon-cyber/cyber-samurai/theme'
import { THEME_PRESET as THEME_PRESET_36 } from '../neon-cyber/cyber-samurai-onyx/theme'
import { THEME_PRESET as THEME_PRESET_37 } from '../neon-cyber/digital-lavender/theme'
import { THEME_PRESET as THEME_PRESET_38 } from '../neon-cyber/dusty-laser/theme'
import { THEME_PRESET as THEME_PRESET_39 } from '../neon-cyber/electric/theme'
import { THEME_PRESET as THEME_PRESET_40 } from '../neon-cyber/electric-sand/theme'
import { THEME_PRESET as THEME_PRESET_41 } from '../neon-cyber/frost-byte/theme'
import { THEME_PRESET as THEME_PRESET_42 } from '../neon-cyber/hologram/theme'
import { THEME_PRESET as THEME_PRESET_43 } from '../neon-cyber/hologram-glass/theme'
import { THEME_PRESET as THEME_PRESET_44 } from '../neon-cyber/laser/theme'
import { THEME_PRESET as THEME_PRESET_45 } from '../neon-cyber/matrix/theme'
import { THEME_PRESET as THEME_PRESET_46 } from '../neon-cyber/matrix-chrome/theme'
import { THEME_PRESET as THEME_PRESET_47 } from '../neon-cyber/molten-pixel/theme'
import { THEME_PRESET as THEME_PRESET_48 } from '../neon-cyber/monokai/theme'
import { THEME_PRESET as THEME_PRESET_49 } from '../neon-cyber/neon-flare/theme'
import { THEME_PRESET as THEME_PRESET_50 } from '../neon-cyber/neon-grid/theme'
import { THEME_PRESET as THEME_PRESET_51 } from '../neon-cyber/plasma/theme'
import { THEME_PRESET as THEME_PRESET_52 } from '../neon-cyber/plasma-frost/theme'
import { THEME_PRESET as THEME_PRESET_53 } from '../neon-cyber/rainy-neon/theme'
import { THEME_PRESET as THEME_PRESET_54 } from '../neon-cyber/static-blossom/theme'
import { THEME_PRESET as THEME_PRESET_55 } from '../neon-cyber/sunset-mainframe/theme'
import { THEME_PRESET as THEME_PRESET_56 } from '../neon-cyber/synthwave/theme'
import { THEME_PRESET as THEME_PRESET_57 } from '../neon-cyber/tokyo-night/theme'
import { THEME_PRESET as THEME_PRESET_58 } from '../organic-world/arctic-clear/theme'
import { THEME_PRESET as THEME_PRESET_59 } from '../organic-world/autumn-night/theme'
import { THEME_PRESET as THEME_PRESET_60 } from '../organic-world/clay-echo/theme'
import { THEME_PRESET as THEME_PRESET_61 } from '../organic-world/cloud-dancer/theme'
import { THEME_PRESET as THEME_PRESET_62 } from '../organic-world/desert-glass/theme'
import { THEME_PRESET as THEME_PRESET_63 } from '../organic-world/forest-console/theme'
import { THEME_PRESET as THEME_PRESET_64 } from '../organic-world/forest-deep/theme'
import { THEME_PRESET as THEME_PRESET_65 } from '../organic-world/meadowland/theme'
import { THEME_PRESET as THEME_PRESET_66 } from '../organic-world/mist/theme'
import { THEME_PRESET as THEME_PRESET_67 } from '../organic-world/mocha-mousse/theme'
import { THEME_PRESET as THEME_PRESET_68 } from '../organic-world/ocean/theme'
import { THEME_PRESET as THEME_PRESET_69 } from '../organic-world/summer-heat/theme'
import { THEME_PRESET as THEME_PRESET_70 } from '../organic-world/summer-heat-noir/theme'
import { THEME_PRESET as THEME_PRESET_71 } from '../organic-world/terra-firme/theme'
import { THEME_PRESET as THEME_PRESET_72 } from '../organic-world/tropic-noise/theme'
import { THEME_PRESET as THEME_PRESET_73 } from '../organic-world/winter-silence/theme'
import { THEME_PRESET as THEME_PRESET_74 } from '../organic-world/winter-solstice/theme'
import { THEME_PRESET as THEME_PRESET_75 } from '../premium-status/ascension/theme'
import { THEME_PRESET as THEME_PRESET_76 } from '../premium-status/golden-ratio/theme'
import { THEME_PRESET as THEME_PRESET_77 } from '../premium-status/imperial-black/theme'
import { THEME_PRESET as THEME_PRESET_78 } from '../premium-status/obsidian-bloom/theme'
import { THEME_PRESET as THEME_PRESET_79 } from '../premium-status/platinum-mist/theme'
import { THEME_PRESET as THEME_PRESET_80 } from '../retro-memory/bitcrush-sunset/theme'
import { THEME_PRESET as THEME_PRESET_81 } from '../retro-memory/cassette/theme'
import { THEME_PRESET as THEME_PRESET_82 } from '../retro-memory/crt-soft/theme'
import { THEME_PRESET as THEME_PRESET_83 } from '../retro-memory/gruvbox/theme'
import { THEME_PRESET as THEME_PRESET_84 } from '../retro-memory/polaroid/theme'
import { THEME_PRESET as THEME_PRESET_85 } from '../retro-memory/vaporwave/theme'
import { THEME_PRESET as THEME_PRESET_86 } from '../retro-memory/vaporwave-sunset/theme'
import { THEME_PRESET as THEME_PRESET_87 } from '../system-core/blueprint/theme'
import { THEME_PRESET as THEME_PRESET_88 } from '../system-core/carbon/theme'
import { THEME_PRESET as THEME_PRESET_89 } from '../system-core/celestial-yellow/theme'
import { THEME_PRESET as THEME_PRESET_90 } from '../system-core/cherry-lacquer/theme'
import { THEME_PRESET as THEME_PRESET_91 } from '../system-core/copper-grid/theme'
import { THEME_PRESET as THEME_PRESET_92 } from '../system-core/core-protocol/theme'
import { THEME_PRESET as THEME_PRESET_93 } from '../system-core/dracula/theme'
import { THEME_PRESET as THEME_PRESET_94 } from '../system-core/energy-orange/theme'
import { THEME_PRESET as THEME_PRESET_95 } from '../system-core/future-dusk/theme'
import { THEME_PRESET as THEME_PRESET_96 } from '../system-core/light-protocol/theme'
import { THEME_PRESET as THEME_PRESET_97 } from '../system-core/mechanical-botanical/theme'
import { THEME_PRESET as THEME_PRESET_98 } from '../system-core/mint-protocol/theme'
import { THEME_PRESET as THEME_PRESET_99 } from '../system-core/nord/theme'
import { THEME_PRESET as THEME_PRESET_100 } from '../system-core/opulence-era/theme'
import { THEME_PRESET as THEME_PRESET_101 } from '../system-core/pop-pink/theme'
import { THEME_PRESET as THEME_PRESET_102 } from '../system-core/refined-grit/theme'
import { THEME_PRESET as THEME_PRESET_103 } from '../system-core/rose-quartz-core/theme'
import { THEME_PRESET as THEME_PRESET_104 } from '../system-core/sandstorm-ui/theme'
import { THEME_PRESET as THEME_PRESET_105 } from '../system-core/shape-theory/theme'
import { THEME_PRESET as THEME_PRESET_106 } from '../system-core/silk-console/theme'
import { THEME_PRESET as THEME_PRESET_107 } from '../system-core/solarized/theme'
import { THEME_PRESET as THEME_PRESET_108 } from '../system-core/steel-horizon/theme'
import { THEME_PRESET as THEME_PRESET_109 } from '../system-core/studio-ink/theme'
import { THEME_PRESET as THEME_PRESET_110 } from '../system-core/terminal/theme'
import { THEME_PRESET as THEME_PRESET_111 } from '../system-core/titanium-dawn/theme'
import { THEME_PRESET as THEME_PRESET_112 } from '../system-core/transformative-teal/theme'
import { THEME_PRESET as THEME_PRESET_113 } from '../urban-expression/brutalist-ui/theme'
import { THEME_PRESET as THEME_PRESET_114 } from '../urban-expression/midnight-city/theme'
import { THEME_PRESET as THEME_PRESET_115 } from '../urban-expression/midnight-city-ultra/theme'
import { THEME_PRESET as THEME_PRESET_116 } from '../urban-expression/night-market/theme'
import { THEME_PRESET as THEME_PRESET_117 } from '../urban-expression/nyc-rebel/theme'
import { THEME_PRESET as THEME_PRESET_118 } from '../urban-expression/skyline-code/theme'
import { THEME_PRESET as THEME_PRESET_119 } from '../urban-expression/underground/theme'
import { THEME_PRESET as THEME_PRESET_120 } from '../urban-expression/urban-concrete/theme'

export const GENERATED_THEME_PRESETS: ThemePreset[] = [
  THEME_PRESET_0,
  THEME_PRESET_1,
  THEME_PRESET_2,
  THEME_PRESET_3,
  THEME_PRESET_4,
  THEME_PRESET_5,
  THEME_PRESET_6,
  THEME_PRESET_7,
  THEME_PRESET_8,
  THEME_PRESET_9,
  THEME_PRESET_10,
  THEME_PRESET_11,
  THEME_PRESET_12,
  THEME_PRESET_13,
  THEME_PRESET_14,
  THEME_PRESET_15,
  THEME_PRESET_16,
  THEME_PRESET_17,
  THEME_PRESET_18,
  THEME_PRESET_19,
  THEME_PRESET_20,
  THEME_PRESET_21,
  THEME_PRESET_22,
  THEME_PRESET_23,
  THEME_PRESET_24,
  THEME_PRESET_25,
  THEME_PRESET_26,
  THEME_PRESET_27,
  THEME_PRESET_28,
  THEME_PRESET_29,
  THEME_PRESET_30,
  THEME_PRESET_31,
  THEME_PRESET_32,
  THEME_PRESET_33,
  THEME_PRESET_34,
  THEME_PRESET_35,
  THEME_PRESET_36,
  THEME_PRESET_37,
  THEME_PRESET_38,
  THEME_PRESET_39,
  THEME_PRESET_40,
  THEME_PRESET_41,
  THEME_PRESET_42,
  THEME_PRESET_43,
  THEME_PRESET_44,
  THEME_PRESET_45,
  THEME_PRESET_46,
  THEME_PRESET_47,
  THEME_PRESET_48,
  THEME_PRESET_49,
  THEME_PRESET_50,
  THEME_PRESET_51,
  THEME_PRESET_52,
  THEME_PRESET_53,
  THEME_PRESET_54,
  THEME_PRESET_55,
  THEME_PRESET_56,
  THEME_PRESET_57,
  THEME_PRESET_58,
  THEME_PRESET_59,
  THEME_PRESET_60,
  THEME_PRESET_61,
  THEME_PRESET_62,
  THEME_PRESET_63,
  THEME_PRESET_64,
  THEME_PRESET_65,
  THEME_PRESET_66,
  THEME_PRESET_67,
  THEME_PRESET_68,
  THEME_PRESET_69,
  THEME_PRESET_70,
  THEME_PRESET_71,
  THEME_PRESET_72,
  THEME_PRESET_73,
  THEME_PRESET_74,
  THEME_PRESET_75,
  THEME_PRESET_76,
  THEME_PRESET_77,
  THEME_PRESET_78,
  THEME_PRESET_79,
  THEME_PRESET_80,
  THEME_PRESET_81,
  THEME_PRESET_82,
  THEME_PRESET_83,
  THEME_PRESET_84,
  THEME_PRESET_85,
  THEME_PRESET_86,
  THEME_PRESET_87,
  THEME_PRESET_88,
  THEME_PRESET_89,
  THEME_PRESET_90,
  THEME_PRESET_91,
  THEME_PRESET_92,
  THEME_PRESET_93,
  THEME_PRESET_94,
  THEME_PRESET_95,
  THEME_PRESET_96,
  THEME_PRESET_97,
  THEME_PRESET_98,
  THEME_PRESET_99,
  THEME_PRESET_100,
  THEME_PRESET_101,
  THEME_PRESET_102,
  THEME_PRESET_103,
  THEME_PRESET_104,
  THEME_PRESET_105,
  THEME_PRESET_106,
  THEME_PRESET_107,
  THEME_PRESET_108,
  THEME_PRESET_109,
  THEME_PRESET_110,
  THEME_PRESET_111,
  THEME_PRESET_112,
  THEME_PRESET_113,
  THEME_PRESET_114,
  THEME_PRESET_115,
  THEME_PRESET_116,
  THEME_PRESET_117,
  THEME_PRESET_118,
  THEME_PRESET_119,
  THEME_PRESET_120,
]
